import { render, staticRenderFns } from "./LocationSelector.vue?vue&type=template&id=38206490&scoped=true&"
import script from "./LocationSelector.vue?vue&type=script&lang=js&"
export * from "./LocationSelector.vue?vue&type=script&lang=js&"
import style0 from "./LocationSelector.vue?vue&type=style&index=0&id=38206490&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38206490",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
